module.exports = __webpack_public_path__ + "45fe54d2740bd244f0c3ace2eebb2869.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/splash.jpg
// module id = NuAE
// module chunks = 2